export class TextureUniform {
  private readonly location: WebGLUniformLocation | null;

  constructor(
    private readonly gl: WebGL2RenderingContext,
    readonly shader: WebGLShader,
    readonly name: string,
    private readonly unit: number,
    private readonly texture: WebGLTexture,
  ) {
    gl.useProgram(shader);
    gl.getUniformLocation(shader, name);
    this.location = gl.getUniformLocation(shader, name);

    if (!this.location) {
      console.warn(
        `Uniform "${name}" not found in shader - uniform is either unused or the name is incorrect`,
      );
    } else {
      gl.uniform1i(this.location, this.unit);
    }
  }

  public bind(): void {
    if (this.location) {
      this.gl.activeTexture(this.gl.TEXTURE0 + this.unit);
      this.gl.bindTexture(this.gl.TEXTURE_2D, this.texture);
    }
  }

  public update(updater: (gl: WebGL2RenderingContext) => void) {
    if (this.location) {
      this.bind();
      updater(this.gl);
    }
  }
}
